module.exports = __webpack_public_path__ + "img/41_43.e3831a44.png";